<template>
  <v-dialog scrollable persistent
    :fullscreen="store.window === 'preview'"
    v-model="config.status.active">
    <FilerCard ref="filer"
      v-if="store.window === 'filer'"
      :books="getBooks"
      @load="openPreview"
      @close="close"
    />
    <PreviewCard ref="preview"
      v-if="store.window === 'preview'"
      :books="getBooks"
      @close="close"
      @done="done"
    />
  </v-dialog>
</template>

<script>
import FilerCard from './filer'
import PreviewCard from './preview'
const DEF = {
  STORE: {
    window: 'filer'
  }
}
export default {
  name: 'authorBbookUpload',
  props: [ 'books' ],
  components: {
    FilerCard,
    PreviewCard
  },
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false,
          dropping: false
        }
      },
      store: {
        window: DEF.STORE.window,
      }
    }
  },
  methods: {
    open: function (req) {
      this.$set(this.store, 'window', DEF.STORE.window)
      this.$set(this.config.status, 'active', true)
      this.$nextTick(() => {
        if (this.$refs.filer) {
          this.$refs.filer.init(req)
        }
      })
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    done: function () {
      this.$emit('done')
      this.close()
    },
    openPreview: function (req) {
      this.$set(this.store, 'window', 'preview')
      setTimeout(() => {
        if (this.$refs.preview) {
          this.$refs.preview.init(req)
        } else {
          console.log('not existing')
        }
      }, 500)
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    getBooks () {
      return this.$props.books || {}
    }
  }
}
</script>